import React from 'react';
import UploadManager from 'components/UploadManager';

const MarginUploads = () => <UploadManager
  uploadType="margin_uploads"
  title="Margin Update"
/>;

export default MarginUploads;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/marginUploads/index.jsx